import { useState, useEffect, useContext } from "react";
import { ReactReduxContext } from 'react-redux';
// import { setRequestError } from "../actions/index";

const useGetOne = (api, path, data) => {
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const [loaded, setLoaded] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (api && !loaded) {
      setItem(null);
      setLoaded(true);
      if (path) {
        setLoaded(false);
        api.getFromApi(path, false)
          .then( (response) => setItem(response.data) )
          .catch( e => {
            // dispatch(setRequestError(JSON.parse(JSON.stringify(e, null, 2))));
          } );
      } else if (data) {
        setLoaded(false);
        setItem(data);
      }
    }
  }, [api, loaded, path, data, dispatch])

  return { item, setItem };
};

export default useGetOne;
